/** First and last name of a user as one string; empty when neither is known. */
export function getUserName(
  user: { firstName?: string | null; lastName?: string | null } | null | undefined,
): string {
  return [user?.firstName, user?.lastName].filter(Boolean).join(' ');
}
